import { render } from "./AttachmentChip.vue?vue&type=template&id=01584e5b&scoped=true"
import script from "./AttachmentChip.vue?vue&type=script&lang=js"
export * from "./AttachmentChip.vue?vue&type=script&lang=js"

import "./AttachmentChip.vue?vue&type=style&index=0&id=01584e5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01584e5b"]])

export default __exports__